<script setup>
function CorrectEmailaddress(SubscriberForm) {
  if (SubscriberForm.pf_Email.value.length > 255) {
    alert("Please enter at most 255 characters in the 'Email address' field.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  if (SubscriberForm.pf_Email.value == "") {
    alert("Please enter a value for the 'Email address' field.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  if (SubscriberForm.pf_Email.value.length < 7) {
    alert("Please enter at least 7 characters in the 'Email address' field.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  pf_Email = SubscriberForm.pf_Email.value;
  var reg =
    /^([a-zA-Z0-9_\-\.\+]*)([a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/;
  if (reg.test(pf_Email) == false) {
    alert("Your email address is not valid. Please try again.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  var counter = 0;
  for (i = 1; i <= SubscriberForm.pf_CounterMailinglists.value; i++) {
    var checkBoxName = "pf_MailinglistName" + i;
    if (
      document.getElementsByName(checkBoxName)[0].checked ||
      document.getElementsByName(checkBoxName)[0].type == "hidden"
    )
      counter++;
  }
  if (counter == 0) {
    alert("One or more mailing lists are required for this form.");
    return false;
  }
  return true;
}
//
document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector('form[name="SubscriberForm"]');
  var input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "g-recaptcha-token");
  input.setAttribute("id", "g-recaptcha-token");
  form.appendChild(input);

  var refreshToken = function () {
    grecaptcha
      .execute("6Lc20eAZAAAAAGQsCu8tKqLu3O5AtdjUrVE9AZtr", {
        action: "subscription_from_submit",
      })
      .then(function (token) {
        input.setAttribute("value", token);
      });
  };

  grecaptcha.ready(function () {
    refreshToken();
    setInterval(function () {
      refreshToken();
    }, 10000);
  });
});
</script>


<template>
  <div class="position-relative bg-color-dark">
    <!-- eslint-disable -->
    <component
      class="d-none"
      is="script"
      src="https://www.google.com/recaptcha/api.js?render=6Lc20eAZAAAAAGQsCu8tKqLu3O5AtdjUrVE9AZtr"
      async
    ></component>

    <!-- eslint-enable -->

    <!--     <cookie-law theme="royal">
      <div slot="message" class="pl-md-5 ml-md-5">
        This site uses cookies 🍪
        <router-link to="privacy-policy" class="d-block text-light"
          >Click here to read more</router-link
        >
      </div>
    </cookie-law> -->

    <Sponsors />
    <b-img
      class="d-none d-sm-block mt-5"
      style="margin-bottom: -1px; width: 100%"
      src="https://res.cloudinary.com/oredev/image/upload/v1713183963/2024/Footer-desktop.png"
    ></b-img>
    <b-img
      fluid
      class="d-block d-sm-none mt-5"
      style="margin-bottom: -1px"
      src="https://res.cloudinary.com/oredev/image/upload/v1713183963/2024/Footer-mobile.png"
    ></b-img>
    <footer class="bg-color-light text-color-dark pt-2">
      <b-container fluid class="">
        <b-row>
          <!-- <b-col xl="2" class="left"> </b-col> -->
          <b-col>
            <b-container>
              <b-row class="text-section py-4">
                <b-col cols="12">
                  <b-img
                    fluid
                    src="https://res.cloudinary.com/oredev/image/upload/v1713166789/2024/title.png"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="mt-1 pt-1 mb-5">
                <b-col cols="12" md="8">
                  <b-row>
                    <b-col cols="12">
                      <div class="newsletter mt-3 mb-1">
                        <h5 class="header">Join the newsletter!</h5>
                        <form
                          action="https://oredev.us8.list-manage.com/subscribe/post?u=58a8d04056a9694a44fdbabf6&amp;id=d4cb377f54&amp;f_id=001806e0f0"
                          method="post"
                          id="mc-embedded-subscribe-form"
                          name="mc-embedded-subscribe-form"
                          class="validate"
                          target="_blank"
                          novalidate
                        >
                          <label class="i-cannot-be-spotted"
                            >Field <br /><input
                              type="text"
                              autocomplete="chrome-off"
                              name="namekjsd"
                          /></label>
                          <div class="input-group d-flex mb-2">
                            <input
                              placeholder="Subscribe to newsletter"
                              aria-label="Subscribe to newsletter"
                              style="border-radius: 0px; height: 42px"
                              value=""
                              type="email"
                              name="EMAIL"
                              :class="effectOnInput ? 'email-effect' : ''"
                              class="form-control required email"
                              id="mce-EMAIL"
                              required
                            />

                            <!--       <div class="input-group-append">
                          <input
                            id="NewsletterSubmit"
                            type="submit"
                            name="Submit"
                            class="input-group-text green-bg text-dark"
                            value=">"
                          />
                        </div> -->
                            <b-button
                              id="NewsletterSubmit"
                              type="submit"
                              name="Submit"
                              class="input-group-text btn-1 d-none d-md-block"
                              style="
                                margin-left: 10px;
                                height: 42px !important;
                                width: 132px !important;
                                font-weight: 400 !important;
                                font-size: 20px;
                                line-height: 25.2px;
                              "
                              value=""
                            >
                              Submit</b-button
                            >
                          </div>

                          <!--p class="text-color-dark mt-3 d-none d-md-block">
                        This site is protected by reCAPTCHA and the Google
                      </p>
                      <p class="mt-n3 d-none d-md-block">
                        <a href="https://policies.google.com/privacy"
                          >Privacy Policy</a
                        >
                        and
                        <a href="https://policies.google.com/terms"
                          >Terms of Service</a
                        >
                        apply.
                      </p-->
                          <b-button
                            id="NewsletterSubmit"
                            type="submit"
                            name="Submit"
                            class="d-block d-md-none btn-1"
                            value=""
                            style="
                              width: 139px !important;
                              height: 40px !important;
                              font-weight: 400 !important;
                              font-size: 20px !important;
                              line-height: 25.2px;
                            "
                          >
                            Submit
                          </b-button>

                          <!--p class="text-color-dark mt-3 d-block d-md-none">
                        This site is protected by reCAPTCHA and the Google

                        <a href="https://policies.google.com/privacy"
                          >Privacy Policy</a
                        >
                        and
                        <a href="https://policies.google.com/terms"
                          >Terms of Service</a
                        >
                        apply.
                      </p-->
                          <!-- Do not change name or type on submit button, to change visible text, change text for \"value\" -->
                          <input
                            type="hidden"
                            name="pf_FormType"
                            value="OptInForm"
                          />
                          <input
                            type="hidden"
                            name="pf_OptInMethod"
                            value="SingleOptInMethod"
                          />
                          <input
                            type="hidden"
                            name="pf_CounterDemogrFields"
                            value="0"
                          />
                          <input
                            type="hidden"
                            name="pf_CounterMailinglists"
                            value="1"
                          />
                          <input
                            type="hidden"
                            name="pf_AccountId"
                            value="10083"
                          />
                          <input type="hidden" name="pf_ListById" value="1" />
                          <input type="hidden" name="pf_Version" value="2" />
                          <input
                            type="hidden"
                            name="pf_MailinglistName1"
                            value="200918"
                          />
                        </form>
                      </div>
                    </b-col>
                    <b-col cols="12" class="d-md-block d-none">
                      <p class="links mb-1 text-color-dark">
                        <router-link to="/about" class
                          >About Öredev</router-link
                        >
                        |
                        <router-link to="/code-of-conduct" class
                          >Code of conduct</router-link
                        >
                        |
                        <router-link to="/archive" class>Archive</router-link> |
                        <router-link to="/committee" class
                          >Committee</router-link
                        >
                        <br class="d-sm-block d-none" />

                        <router-link to="/partnership" class
                          >Partnership</router-link
                        >
                        |
                        <router-link to="/privacy-policy" class
                          >Privacy Policy</router-link
                        >
                        |
                        <router-link to="/convince-your-boss" class
                          >Convince your boss</router-link
                        >
                        |
                        <a
                          href="https://drive.google.com/file/d/1C55YFsdXGk-kOF6Dnyy3ASHIYO-ZOxPp/view?usp=drive_link"
                          class
                          >Volunteer at Øredev</a
                        >
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="4" cols="12">
                  <div class="mt-3 mb-3">
                    <div class="social-media">
                      <p class="mb-1">Keep in touch</p>
                      <p class="mb-1">
                        Email:
                        <a
                          href="mailto:info@oredev.org"
                          style="
                            color: #1e1c1d !important;
                            font-weight: 300 !important;
                          "
                          >info@oredev.org</a
                        >
                      </p>
                      <p class="mb-1">Öredev AB</p>
                      <div class="d-flex">
                        <a
                          @mouseover="instagramHover = '_yellow.svg'"
                          @mouseleave="instagramHover = '.svg'"
                          href="https://www.instagram.com/oredev/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            :src="
                              $_appendToUrl(
                                'https://res.cloudinary.com/oredev/image/upload/v1716880804/2024/Icons.svg/Instagram',
                                instagramHover
                              )
                            "
                            alt="Instagram"
                        /></a>

                        <a
                          @mouseover="facebookHover = '_yellow.svg'"
                          @mouseleave="facebookHover = '.svg'"
                          href="https://www.facebook.com/oredev"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="ml-2"
                        >
                          <img
                            :src="
                              $_appendToUrl(
                                'https://res.cloudinary.com/oredev/image/upload/v1712403077/2024/Icons.svg/Facebook',
                                facebookHover
                              )
                            "
                            alt="Facebook"
                          />
                        </a>

                        <a
                          @mouseover="linkedinHover = '_yellow.svg'"
                          @mouseleave="linkedinHover = '.svg'"
                          href="https://www.linkedin.com/company/oredev/"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="ml-2"
                        >
                          <img
                            :src="
                              $_appendToUrl(
                                'https://res.cloudinary.com/oredev/image/upload/v1712403077/2024/Icons.svg/Linkedin',
                                linkedinHover
                              )
                            "
                            alt="Linkedin"
                          />
                        </a>

                        <a
                          @mouseover="twitterHover = '_yellow.svg'"
                          @mouseleave="twitterHover = '.svg'"
                          href="https://www.twitter.com/oredev/"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="ml-2"
                        >
                          <img
                            :src="
                              $_appendToUrl(
                                'https://res.cloudinary.com/oredev/image/upload/v1712403077/2024/Icons.svg/Twitter',
                                twitterHover
                              )
                            "
                            alt="Twitter"
                          />
                        </a>

                        <a
                          @mouseover="youtubeHover = '_yellow.svg'"
                          @mouseleave="youtubeHover = '.svg'"
                          href="https://www.youtube.com/c/%C3%98redevConference"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="ml-2"
                        >
                          <img
                            :src="
                              $_appendToUrl(
                                'https://res.cloudinary.com/oredev/image/upload/v1712403077/2024/Icons.svg/Youtube',
                                youtubeHover
                              )
                            "
                            alt="Youtube"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" class="d-md-none d-block">
                  <p class="links mb-1 text-color-dark">
                    <router-link to="/about" class>About Öredev</router-link>
                    |
                    <router-link to="/code-of-conduct" class
                      >Code of conduct</router-link
                    >
                    |
                    <router-link to="/archive" class>Archive</router-link> |
                    <router-link to="/committee" class>Committee</router-link>
                    <br class="d-sm-block d-none" />

                    <router-link to="/partnership" class
                      >Partnership</router-link
                    >
                    |
                    <router-link to="/privacy-policy" class
                      >Privacy Policy</router-link
                    >
                    |
                    <router-link to="/convince-your-boss" class
                      >Convince your boss</router-link
                    >
                    |
                    <a
                      href="https://drive.google.com/file/d/1C55YFsdXGk-kOF6Dnyy3ASHIYO-ZOxPp/view?usp=drive_link"
                      class
                      >Volunteer at Øredev</a
                    >
                  </p>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import Sponsors from "./Sponsors.vue";
import { helperMethods } from "../mixins/helpers";

export default {
  components: { CookieLaw, Sponsors },
  mixins: [helperMethods],
  name: "Footer",
  data() {
    return {
      email: "",
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      instagramHover: ".svg",
      facebookHover: ".svg",
      linkedinHover: ".svg",
      twitterHover: ".svg",
      youtubeHover: ".svg",
    };
  },
  updated: function () {},
  mounted: function () {},
  beforeMount: function () {},
  methods: {
    isEmailValid: function () {
      return this.email == ""
        ? ""
        : this.reg.test(this.email)
        ? "has-success"
        : "has-error";
    },
  },

  computed: {
    effectOnInput() {
      return this.$store.getters.getEffect;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";

footer {
  padding: 10rem 0 0 0;
  // background: url(https://res.cloudinary.com/oredev/image/upload/2019/html/background-footer);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;

  /*  @media (min-width: 1000px) and (max-width: 1500px) {
    margin-top: -600px;
    padding: 5rem 0 2rem 0;
  }

  @media (min-width: 1500px) {
    margin-top: -626px;
    padding: 5rem 0 2rem 0;
  } */
}
footer h2,
footer h3 {
  text-transform: uppercase;
  margin: 0;
}
footer h2 {
  font-size: 2.7rem;
  margin-bottom: 30px;
  @media (max-width: 767px) {
    font-size: 2rem;
    margin-bottom: 10px;
  }
  @media (max-width: 576px) {
    font-size: 1.7rem;
  }
}
footer h3 {
  font-size: 2rem;
  @media (max-width: 767px) {
    font-size: 1.4rem;
  }
  @media (max-width: 576px) {
    font-size: 1.1rem;
  }
}

footer p.links {
  color: $text-dark !important;
}
footer p {
  color: $text-dark !important;
}
footer a {
  color: $text-dark !important;
}

footer .social-media {
  @media screen and (min-width: 767px) {
    font-size: 17px;
    line-height: 33px;
    float: right;
    padding-top: 10px;
  }
  font-size: 14px;
  line-height: 22px;
}

footer .middle {
  padding: 120px 0;
}
footer .newsletter {
  width: 100%;
  display: inline-block;
}
footer .left {
  background: url(https://res.cloudinary.com/oredev/image/upload/2019/html/theme-left-bottom);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom right;
}
footer .right {
  background: url(https://res.cloudinary.com/oredev/image/upload/2019/html/theme-right-bottom);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom left;
}
footer .links a {
  color: $text-dark !important;
  font-size: 1rem;
}
footer .links a:hover {
  color: $yellow !important;
}
>>> .Cookie--royal .Cookie__button {
  background: $yellow !important;

  width: 194px !important;
  height: 56px !important;
  background-color: $yellow !important;
  color: $text-dark !important;
  border: 2px solid $yellow !important;
  border-radius: 30px !important;
}

>>> .Cookie--royal .Cookie__button:hover {
  color: $text-dark !important;
  background: white !important;
}

>>> .Cookie--royal {
  background-color: $green;
  color: $text-color-light;
}

.i-cannot-be-spotted {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}

#NewsletterSubmit {
  background: $yellow !important;
}

#NewsletterSubmit:hover {
  background: #d89338 !important;
  color: black !important;
}

.newsletter .header {
  font-weight: 500 !important;
  font-size: 24px !important;
  line-height: 33px;
  margin-bottom: 16px;
}

@media screen and (max-width: 767px) {
  .newsletter .header {
    margin-bottom: 8px;
  }

  .form-control {
    width: 80% !important;
  }

  #NewsletterSubmit {
    width: 15% !important;
  }
}

.email-effect {
  border: 1px solid lightgray;
  height: 40px;
  padding: 0 10px;
  width: 200px;
  animation: glow 1000ms ease-out 10 alternate;
  outline: none;
}

@keyframes glow {
  0% {
    box-shadow: 0 0 5px rgba(252, 163, 24, 0.2);
  }
  100% {
    box-shadow: 0 0 20px rgba(252, 163, 24, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue